import { sbMsgBus as sbMsgBusImported } from "./mbus";
import { GeoTopics, GeneralTopics } from "./MessageBusTopics";

export * from "./mbus";
export * from "./MessageBusTopics";

export const sbMsgBusPredefinedTopics = {
    GeneralTopics,
    GeoTopics
};

// TODO: OFTL-115
sbMsgBusImported["sbMsgBusPredefinedTopics"] = sbMsgBusPredefinedTopics;

export const sbMsgBus = sbMsgBusImported;